"use strict";
/* ERRORS */
Object.defineProperty(exports, "__esModule", { value: true });
const Errors = {
    storeNotFound: () => {
        return new Error('Store not found, it either got garbage-collected (you must keep a reference to it) or you are passing "store" a non-proxied store somewhere');
    },
    storesEmpty: () => {
        return new Error('An empty array of stores has been provided, you need to provide at least one store');
    }
};
/* EXPORT */
exports.default = Errors;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQ0EsWUFBWTs7QUFFWixNQUFNLE1BQU0sR0FBRztJQUViLGFBQWEsRUFBRSxHQUFVLEVBQUU7UUFFekIsT0FBTyxJQUFJLEtBQUssQ0FBRyw2SUFBNkksQ0FBRSxDQUFDO0lBRXJLLENBQUM7SUFFRCxXQUFXLEVBQUUsR0FBVSxFQUFFO1FBRXZCLE9BQU8sSUFBSSxLQUFLLENBQUcsb0ZBQW9GLENBQUUsQ0FBQztJQUU1RyxDQUFDO0NBRUYsQ0FBQztBQUVGLFlBQVk7QUFFWixrQkFBZSxNQUFNLENBQUMifQ==